import {ScatterGL} from 'scatter-gl';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      scattergl: ScatterGL
    }
  }
});
